import { Box } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSnackbarContext } from "../services/snackbar"

import QRCode from "../assets/png/qr-code.png"

const notFoundErrorTextPool = [
  "Cette adresse ne mène nulle part, on vous a donc mis ici pour vous faire réfléchir un peu. Vous pouvez réessayer, mais pas avec la même adresse svp.",
  "Bien tenté ! Mais non, on ne peut pas juste écrire n'importe quoi dans la barre d'adresse. Vous pouvez réessayer, ça pourrait finir par marcher...",
  "Cette page n'est pas... Ça tombe bien, cette page ne pense pas non plus. On remercie René Descartes pour ce passage philosophique, et on passe à autre chose.",
  "Peu importe ce que vous cherchiez, vous n'êtes pas au bon endroit. A moins que vous ne vouliez vraiment provoquer une erreur 404, auquel cas, bravo... J'imagine ?",
  "Dans le World Wide Web, l'erreur 404 signale que la ressource demandée, généralement une page Web, n'a pas été trouvée. Elle est souvent accompagnée d'un message avec les mots « pas trouvé » ou not found en anglais.",
  "Ce lien est erroné. Hyris décline toute responsabilité liée à cet incident et la redirige vers la personne qui vous a fourni ce lien. Ou vers vous, à défaut.",
  "Oui, les développeurs se sont donnés du mal pour faire une jolie page d'erreur 404. Tout ça pour vous dire que vous n'êtes pas au bon endroit et qu'il faut changer d'URL.",
  "Le pôle Geek d'Hyris vous souhaite un excellent séjour sur son site web ! Cependant, nous vous conseillons de commencer par une page qui existe vraiment.",
  "Non ! Il n'y a rien ici ! Et ce sera pareil si vous essayez hyris.tv/nqodsivnbqsklmckvpoakbjzn ! Vous pouvez nous croire, on a essayé nous-mêmes.",
]

export const Limbo = ({ special = false }: { special?: boolean }): React.ReactElement => {
  const navigate = useNavigate()
  const [message] = useState<string>(notFoundErrorTextPool[Math.floor(Math.random() * notFoundErrorTextPool.length)])
  const { open: sbOpen } = useSnackbarContext()

  useEffect(() => {
    if (special) {
      sbOpen("On vous l'avait dit...", "info")
    }
  }, [])

  return (
    <Box
      sx={{
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        backgroundColor: "#0077D6",
        color: "#ffffff",
        textAlign: "justify",
        paddingX: "10%",
        paddingTop: "5%",
        paddingBottom: "10%",
      }}
    >
      <h1 style={{ fontSize: "10rem", fontWeight: "normal", margin: 0 }}>{":("}</h1>
      <h2 style={{ fontSize: "2rem", fontWeight: "normal" }}>{message}</h2>
      <h2 style={{ fontSize: "2rem", fontWeight: "normal" }}>{"Erreur 404"}</h2>
      <img src={QRCode} style={{ width: "150px", height: "150px", marginRight: "10px", float: "left" }} />
      <div>
        <p style={{ marginTop: 0 }}>
          {
            "Après avoir revérifié, on peut vous confirmer que cette page n'existe effectivement pas. Le QR-code ci-contre vous mènera à une page qui existe."
          }
        </p>
        <p>
          <span onClick={() => navigate("/")} style={{ textDecoration: "underline", cursor: "pointer" }}>
            {"Retour à l'accueil"}
          </span>
        </p>
      </div>
    </Box>
  )
}
